import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../shared/SafeIcon';

export default function AdviceSection({ data }) {
  const { financial, medical, cognitive, timeline } = data;
  
  const adviceItems = [];

  // Financial Advice
  if (financial.includes("Over £23,250")) {
    adviceItems.push({
      title: "Self-Funding Strategy",
      content: "As a self-funder, you have more choice in providers. However, ensure you've applied for 'Attendance Allowance'—it's non-means-tested and could provide up to £108/week regardless of your savings.",
      icon: FiIcons.FiDollarSign
    });
  } else if (financial.includes("Under £14,250")) {
    adviceItems.push({
      title: "Local Authority Funding",
      content: "You should be eligible for maximum support. Contact your local Social Services for a 'Financial Assessment' immediately to start the funding process.",
      icon: FiIcons.FiHome
    });
  }

  // Medical/Nursing Advice
  if (medical.includes("24/7") || medical.includes("Specialist")) {
    adviceItems.push({
      title: "NHS CHC Assessment",
      content: "Due to high medical needs, you must ask for an NHS Continuing Healthcare (CHC) checklist. If awarded, the NHS pays for everything, including your care home fees.",
      icon: FiIcons.FiActivity
    });
  }

  // Dementia Specific Advice
  if (cognitive.includes("Advanced") || cognitive.includes("Moderate")) {
    adviceItems.push({
      title: "Dementia Specialist Care",
      content: "Look specifically for 'Dementia Registered' homes or agencies. They have specialized environments and staff trained in 'Person-Centered' dementia care to reduce agitation.",
      icon: FiIcons.FiHeart
    });
  }

  // Hospital Discharge
  if (timeline.includes("Hospital")) {
    adviceItems.push({
      title: "Safe Discharge",
      content: "The hospital discharge team cannot send your loved one home until a safe care plan is in place. You have the right to challenge a discharge if you feel it's unsafe.",
      icon: FiIcons.FiAlertCircle
    });
  }

  return (
    <div className="space-y-6">
      <h3 className="text-xl font-bold text-slate-900">Tailored Advice for You</h3>
      <div className="grid grid-cols-1 gap-4">
        {adviceItems.map((item, i) => (
          <div key={i} className="flex gap-4 p-5 rounded-2xl bg-white border border-slate-100 shadow-sm">
            <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-teal-50 text-teal-600 flex items-center justify-center">
              <SafeIcon icon={item.icon} />
            </div>
            <div>
              <h4 className="font-bold text-slate-900 mb-1">{item.title}</h4>
              <p className="text-slate-600 text-sm leading-relaxed">{item.content}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}